
cc.Class({
    extends: cc.Component,

    properties: {
        refresh: {
            default: false,
            notify: function() {
                if (!this.container || !CC_EDITOR) {
                    return;
                }
                if (this.refresh) {
                    this.init([10, 25, 50, 100, 250, 500, 1000, Number.MAX_SAFE_INTEGER], 0, (index) => {
                        cc.log(index);
                    });
                } else {
                    this.container.children.forEach(child => child.destroy());
                    this.buttons = null;
                }
            }
        },
        container: cc.Node,
        buttonPrefab: cc.Prefab,
        toggleContainer: cc.ToggleContainer
    },

    init (values, selectedIndex, callback, decorator = null, stateModifiers = []) {
        this.values = values;
        this.callback = callback;
        this.stateModifiers = stateModifiers;
        this.buttons = [];
        this.selectedIndex = selectedIndex;

        this.values.forEach((value, i) => {
            const buttonNode = cc.instantiate(this.buttonPrefab);
            const toggle = buttonNode.getComponent(cc.Toggle);

            this.buttons.push(toggle);

            buttonNode.parent = this.container;
            buttonNode.realValue = value;
            toggle.isChecked = i === selectedIndex;

            const icon = buttonNode.getChildByName('icon');
            const label = buttonNode.getChildByName('label');

            if (value === Number.MAX_SAFE_INTEGER) {
                icon.active = true;
                label.active = false;
            } else {
                icon.active = false;
                label.active = true;
                if (decorator) {
                    label.getComponent(cc.Label).string = decorator(value);
                } else {
                    label.getComponent(cc.Label).string = value;
                }
            }
        });

        this.applyModifier();
    },

    select(index) {
        this.selectedIndex = index;
        if (!this.buttons) {
            return;
        }
        // Trick to be able to unselect current one, and select wanted button
        this.toggleContainer.allowSwitchOff = true;

        for (let i = 0; i < this.buttons.length; i ++ ) {
            const button = this.buttons[i];

            button.isChecked = i === index;
        }
        this.toggleContainer.allowSwitchOff = index === -1;
    },

    applyModifier () {
        if (!this.buttons) {
            return;
        }
        for (let i = 0; i < this.buttons.length; i ++ ) {
            const button = this.buttons[i];

            for (let j = 0; j < this.stateModifiers.length; j++) {
                const modifier = this.stateModifiers[j];
                modifier(button, button.node.realValue);

                // button.interactable = modifier(button.node.realValue);
                // button.node.opacity = button.interactable ? 255 : 100;
            }
        }
    },

    onToggled () {
        for (let i = 0; i < this.buttons.length; i ++) {
            if (this.buttons[i].isChecked) {
                if (this.callback) {
                    this.callback(i);
                }
                return;
            }
        }
    },

    disable () {

    },

    enable () {

    },
});
